import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import { formatInputDate } from "../../../utils/Time";
import { useAuth } from "../../../context/AuthContext";
import { useAlert } from "../../../context/AlertContext";
import { formatDate } from "../../../commons/FormatValue";
import { getServiceRequest } from "../../../commons/ServiceRequest";
import {
  filteredItemByDateBetween,
  filteredItemInArray,
  filteredMultiItemInArray,
  findItemInArray
} from "../../../utils/ManageArray";
import {
  initializeSetOption,
  initializeSetOptionMulti
} from "../../../utils/InitializeSetDefault";
import TableForm from "../../TableForm";
import ConfirmModal from "../../ConfirmModal";
import SearchFilter from "../../SearchFilter";
import CardDisplayComponent from "../../CardDisplayComponent";
import EmployeesService from "../../../services/employee.service";
import InformInstallJobsService from "../../../services/informinstalljob.service";
import { PreviewIcon } from "../../../data/iconImage";
import ReasonsService from "../../../services/reasons.service";
import InFormInstallAcceptService from "../../../services/informinstallaccept.service";

const CreateCheckForm = ({ editData, onSubmitCallback }) => {
  const { user } = useAuth();
  const { state } = useLocation();
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const [searchValue, setSearchValue] = useState(state?.Search || []);
  const [Install, setInstall] = useState([]);
  const [Reasons, setReasons] = useState([]);
  const [Employee, setEmployee] = useState([]);
  const defaultData = {
    company_code: user.Com_Code,
    inform_install_job_id: null,
    job_type_id: null,
    accept_by_id: null,
    install_accept_date: !editData ? new Date().toISOString() : null,
    install_accept_no: "",
    inst_reject: null,
    reason_desc: null
  };
  const [data, setData] = useState({ Array: [defaultData] });
  const searchField = [
    { name: "START", label: "จากวันที่แจ้งงานติดตั้ง", type: "date" },
    { name: "END", label: "ถึงวันที่แจ้งงานติดตั้ง", type: "date" }
  ];
  const inputField = [
    // {
    //   name: "JobType.Job_Type_Name",
    //   label: "ประเภทงาน",
    //   readOnly: true,
    //   noneRequired: true
    // },
    {
      name: "Install_Doc_Date",
      label: "วันที่แจ้ง",
      readOnly: true,
      noneRequired: true,
      format: (row) => formatDate(row?.Install_Doc_Date)
    },
    {
      name: "Install_Doc_No",
      label: "เลขที่แจ้ง",
      readOnly: true,
      noneRequired: true
    },
    // {
    //   name: "BPCustomer.Cus_Code",
    //   label: "รหัสลูกค้า/สาขา",
    //   readOnly: true,
    //   noneRequired: true
    // },
    // {
    //   name: "BPCustomer.Cus_NumBranch",
    //   label: "เลขที่สาขา",
    //   readOnly: true,
    //   noneRequired: true
    // },
    {
      name: "BPCustomer.Cus_Name",
      label: "ชื่อลูกค้า/สาขา",
      readOnly: true,
      noneRequired: true
    },
    {
      name: "Employee.Employee_Name",
      label: "ผู้แจ้ง",
      readOnly: true,
      plusString: ["Employee.Employee_Name", "Employee.Employee_Surname"]
    },
    {
      name: "install_accept_date",
      label: "วันที่ตรวจรับงาน",
      type: "date",
      format: (value) =>
        value?.install_accept_date &&
        formatInputDate(value?.install_accept_date, "Local")?.date
    },
    {
      name: "accept_by_id",
      label: "ผู้ตรวจรับ",
      type: "select",
      minKeywordLength: 1,
      filterBy: ["Employee_Name", "Employee_Surname"],
      options: initializeSetOptionMulti({
        key: "Id",
        label: ["Employee_Name", "Employee_Surname"],
        operator: " ",
        dataset: state?.Employee ? state?.Employee : Employee
      }),
      queryService: (query) =>
        getServiceRequest({
          showAlert,
          setLoading,
          serviceRequest: EmployeesService.getAllEmployees(query),
          callback: ({ items }) => setEmployee(items)
        })
    },
    {
      name: "inst_reject",
      label: "สถานะการรับ",
      type: "select",
      disabled: editData && true,
      options: [
        { value: true, label: "ACCEPT" },
        { value: false, label: "REJECT" }
      ],
      noneAsync: true
    },
    {
      name: "reason_mas_id",
      label: "เหตุผลไม่รับงาน",
      type: "select",
      disabled: editData && true,
      minKeywordLength: 1,
      filterBy: ["Reason_Desc"],
      options: !editData
        ? initializeSetOption({
            key: "Id",
            label: "Reason_Desc",
            dataset: Reasons
          })
        : [{ value: null, label: " " }]
    }
  ];

  const handleSearchFilter = async (search) => {
    setSearchValue(search);

    const [start, end] = search?.filter(({ name }) =>
      ["START", "END"].some((suffix) =>
        name.toUpperCase().includes(suffix.toUpperCase())
      )
    );

    if (start?.value && end?.value) {
      const filteredData = filteredItemByDateBetween(
        Install,
        start?.value,
        end?.value,
        !editData
          ? "Install_Doc_Date"
          : "inform_install_job_items.Install_Doc_Date"
      );

      if (!editData) {
        const mapData = [];

        for (let index = 0; index < filteredData.length; index++) {
          const response = await InFormInstallAcceptService.generateAcceptNo();
          mapData.push({
            ...response,
            ...filteredData[index]
          });
        }

        setData({
          Array: mapData.map((item) => ({
            ...item,
            install_accept_date: new Date().toISOString()
          }))
        });
      } else {
        const fetchData = async () => {
          setData({
            Array: await Promise.all(
              filteredData.map(async (data) => {
                const employeesResponse = await EmployeesService.getEmployees(
                  data?.accept_by_id
                );
                setEmployee((prevState) => [...prevState, employeesResponse]);

                const informInstallResponse = data?.inform_install_job_items;
                return { ...informInstallResponse, ...data };
              })
            )
          });
        };

        // เรียกใช้งานฟังก์ชัน fetchData
        fetchData();
      }
    }
  };

  const handleValidated = (event) => {
    event.preventDefault();
    const form = event?.currentTarget;
    if (!form?.checkValidity()) {
      event?.stopPropagation();
      setValidated(true);
    } else {
      setShowModal(true);
    }
  };

  const handleSubmit = (event, { dataCallback, showCallback }) => {
    event.preventDefault();

    setShowModal(showCallback);
    if (dataCallback) {
      const { data } = dataCallback;
      const newData = data?.Array?.map((item) => ({
        id: editData && item?.id,
        company_code: item?.company_code,
        inform_install_job_id: item?.inform_install_job_id,
        job_type_id: item?.job_type_id,
        accept_by_id: item?.accept_by_id,
        install_accept_date: item?.install_accept_date,
        install_accept_no: item?.install_accept_no,
        reason_mas_id: item?.reason_mas_id,
        inst_reject: item?.inst_reject
      }));

      onSubmitCallback(newData);
    }
  };

  useEffect(() => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: ReasonsService.getAllReasons(),
      callback: (res) =>
        setReasons(
          filteredMultiItemInArray(res, "JobType.Job_Type_Code", ["001"]) &&
            filteredMultiItemInArray(res, "Job_Type_Id", ["1"])
        )
    });

    if (!editData) {
      getServiceRequest({
        showAlert,
        setLoading,
        serviceRequest: InformInstallJobsService.getAllInformInstallJobs(),
        callback: (res) =>
          setInstall(
            filteredMultiItemInArray(res, "Inform_Install_Status", ["OPEN"])
          )
      });
    } else {
      getServiceRequest({
        showAlert,
        setLoading,
        serviceRequest: InFormInstallAcceptService.getAllInFormInstallAccept(),
        callback: (res) =>
          setInstall(filteredItemInArray(res, "inst_reject", true))
      });
    }

    if (state?.Search) setData({ Array: state?.data });
  }, [editData]);

  return (
    <>
      <CardDisplayComponent
        header={{
          title: {
            text: "ค้นหารายการแจ้ง",
            className: "text-center"
          }
        }}
        body={{
          element: (
            <SearchFilter
              data={Install}
              inputField={state?.Search ? state?.Search : searchField}
              fieldClassName={{
                inputRow: "justify-content-center align-items-center"
              }}
              searchCallback={handleSearchFilter}
            />
          )
        }}
      />
      <Form noValidate validated={validated} onSubmit={handleValidated}>
        <CardDisplayComponent
          body={{
            element: (
              <TableForm
                data={data?.Array}
                columns={inputField}
                defaultData={defaultData}
                activeButton={[]}
                onChangeCallback={(newData) => {
                  setData({
                    Array: newData?.map((item) => ({
                      ...defaultData,
                      ...item,
                      inform_install_job_id: item?.Id,
                      install_accept_date: item?.install_accept_date,
                      job_type_id: item?.JobType?.Id,
                      accept_by_id: item?.accept_by_id,
                      reason_mas_id: item?.reason_mas_id || null,
                      inst_reject: item?.inst_reject
                    }))
                  });
                }}
                linkBtn={[
                  {
                    state: {
                      ...state,
                      data,
                      name: "data",
                      type: "Check",
                      Search: searchValue,
                      Employee
                    },
                    button: {
                      color: "light",
                      className:
                        "h-100 p-2 bg-light bg-opacity-0 border-light border-opacity-0 rounded-circle "
                    },
                    icon: { src: PreviewIcon, alt: "Preview Icon" }
                  }
                ]}
              />
            )
          }}
          footer={{
            className: "text-end",
            element: (
              <>
                <Button
                  type="submit"
                  variant="success"
                  className="me-2 px-5 py-2 text-dark rounded-pill"
                >
                  {state?.name === "edit" ? "บันทึกการแก้ไข" : "บันทึกข้อมูล"}
                </Button>

                <ConfirmModal
                  show={showModal}
                  data={{ data }}
                  content={editData ? "edit" : "save"}
                  onSubmitCallback={handleSubmit}
                />
              </>
            )
          }}
        />
      </Form>
    </>
  );
};
CreateCheckForm.propTypes = {
  editData: PropTypes.object,
  onSubmitCallback: PropTypes.func
};

export default CreateCheckForm;
